/*@flow*/
import * as t from 'lib/t';
import StatusesTemplate from './templates/Statuses';
import Section from './templates/Section';
import AsyncTemplate from './templates/AsyncTemplate';
import getFiltersQuery from 'lib/getFiltersQuery';
import * as loaders from 'queries/loaders';

const config = {
  status: t.list(t.String).opt({
    label: 'Status',
    template: StatusesTemplate,
    filterName: 'units',
  }),
  category: t.list(t.String).opt({
    legend: 'Category',
    template: AsyncTemplate,
    className: 'unit-categories-select-field',
    placeholder: 'Select categories',
    loadValues: (o) => {
      const keys = ['units', 'bbox', 'areaId'];
      const filters = getFiltersQuery()
        .filter((_, k) => keys.includes(k))
        .toJS();
      return loaders.unitCategoryLoader({ ...o, filters });
    },
  }),
  tags: t.list(t.String).opt({
    legend: 'Tags',
    template: AsyncTemplate,
    className: 'unit-tags-select-field',
    placeholder: 'Select tags',
    loadValues: (o) => {
      const keys = ['units', 'bbox', 'areaId'];
      const filters = getFiltersQuery()
        .filter((_, k) => keys.includes(k))
        .toJS();
      return loaders.unitTagsLoader({ ...o, filters });
    },
  }),
};

export default t.struct(config).opt<any>({
  label: 'Units',
  iconClass: 'fa-building',
  template: Section,
});
